export enum EnumMergeQuantityMode {
  BY_ARTICLE,
  BY_GROUPING_CODE
}

